"use client"

import { UserRoundX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UserRoundXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UserRoundXIcon = component(Icon)({ as: UserRoundX })
